import { registerHandler } from "../handler";
import { isCountry } from "src/utils/userSegment";
import { fpdTrackPurchase } from "src/vendor/tag4arm";

function isUKGeolocation() {
  return isCountry(["UK", "GB", "IE"]);
}

// UK TV - All Response Media - Tag4ARM
export default function registerHandlers() {
  registerHandler("purchase", ({ order, userId }) => {
    if (isUKGeolocation()) {
      fpdTrackPurchase(`${order.erev_9_months}`, userId);
    }
  });
}
